import React from "react";
import { Navigate } from "react-router-dom";
import { CenterContainerStyled } from "../components/styled/CenterContainerStyled";
import { PagePath } from "../navigation/routes";
import { useAppSelector } from "../store/hooks";
import { getDefaultHomePath } from "../utils/userPermissions";
import { ClipLoader } from "react-spinners";

export const Initial = () => {
  const isLoggedIn = useAppSelector((s) => s.user.isLoggedIn);
  const userType = useAppSelector((s) => s.user.info?.type);
  return (
    <CenterContainerStyled>
      <ClipLoader />
      <Navigate
        to={isLoggedIn ? getDefaultHomePath(userType) : PagePath.login}
        replace={true}
      />
    </CenterContainerStyled>
  );
};
